import type { Testimonial } from "@/types/content";

export const siteInfo = {
  name: "瓜线",
  fullName: "瓜线 · 热门吃瓜时间线",
  slogan: "热门吃瓜来龙去脉，一次看懂完整故事线",
  description:
    "瓜线专注热门吃瓜事件的来龙去脉梳理，用时间线与前因后果复盘，帮你理清复杂的人物关系和剧情反转，不再吃残瓜。",
  email: "hello@gualine.example.com",
  submitEmail: "tip@gualine.example.com",
  since: "2024",
};

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "事件库", path: "/events" },
  { name: "关于我们", path: "/about" },
];

export const siteStats = [
  { value: "1,280+", label: "已梳理事件" },
  { value: "9,600+", label: "时间线节点" },
  { value: "38 万", label: "长期追瓜用户" },
  { value: "每日", label: "热点更新频率" },
];

export const principles = [
  {
    icon: "ri-route-line",
    title: "按时间线整理",
    desc: "拒绝把不同时间发生的事混在一起说，每个节点都有明确的时间坐标，避免被拼接出的叙事误导。",
  },
  {
    icon: "ri-links-line",
    title: "理清人物关系",
    desc: "把事件中出现的各方角色、立场与利益关系单独列出，让「谁和谁是一伙的」不再靠猜。",
  },
  {
    icon: "ri-error-warning-line",
    title: "标注求证状态",
    desc: "官方回应、媒体核实、匿名爆料分级标注，未证实的说法绝不写成结论，给判断留出空间。",
  },
  {
    icon: "ri-history-line",
    title: "进展只增不改",
    desc: "有新进展就在时间线末尾追加节点，保留历史版本，方便你前后对照，看清剧情是怎么翻转的。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "追瓜的阿元",
    role: "从 2024 年追到现在",
    text: "以前刷热搜只觉得信息很碎，看完瓜线的时间线才发现，很多我以为的「突然反转」其实早有伏笔。",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20friendly%20flat%20illustration%20of%20a%20young%20person%20avatar%20with%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20simple%20geometric%20shapes%2C%20clean%20modern%20style&width=200&height=200&seq=gualine-avatar-01&orientation=squarish",
  },
  {
    name: "内容编辑 小满",
    role: "每天看事件库更新",
    text: "「进展只增不改」这一点特别打动我。回头看旧节点还在，能明显感到事件是怎么一步步走到今天的。",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20friendly%20flat%20illustration%20of%20a%20young%20woman%20avatar%20with%20warm%20teal%20and%20cream%20tones%2C%20soft%20beige%20background%2C%20simple%20geometric%20shapes%2C%20clean%20modern%20style&width=200&height=200&seq=gualine-avatar-02&orientation=squarish",
  },
  {
    name: "只看结论的老周",
    role: "通勤路上快速补课",
    text: "时间线做得清楚，人物关系表也很实用。十分钟能把一个吵了一周的事看明白，省了到处翻截图。",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20friendly%20flat%20illustration%20of%20a%20mature%20man%20avatar%20with%20warm%20amber%20and%20coral%20tones%2C%20soft%20cream%20background%2C%20simple%20geometric%20shapes%2C%20clean%20modern%20style&width=200&height=200&seq=gualine-avatar-03&orientation=squarish",
  },
];

export const rankingLabels = [
  { key: "heat", name: "热度榜" },
  { key: "latest", name: "最新更新" },
];